const DotPattern = () => {
  return (
    <div
      className="absolute inset-0 -z-10"
      style={{
        background: "#ffffff",
        backgroundImage:
          "radial-gradient(circle at 1px 1px, rgba(0, 0, 0, 0.09) 1px, transparent 0)",
        backgroundSize: "20px 20px",
      }}
    />
  );
};

export default DotPattern;
